import { render } from "./EcoEvents.vue?vue&type=template&id=6e21bb5a&scoped=true"
import script from "./EcoEvents.vue?vue&type=script&lang=js"
export * from "./EcoEvents.vue?vue&type=script&lang=js"

import "./EcoEvents.vue?vue&type=style&index=0&id=6e21bb5a&scoped=true&lang=scss"

import exportComponent from "/opt/tracking-bg-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e21bb5a"]])

export default __exports__